import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { ArrowRight, Shield, CheckCircle2 } from "lucide-react";

export default function CTASection() {
  return (
    <section className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 bg-slate-950 relative overflow-hidden" data-testid="cta-section">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-600/5 rounded-full blur-[150px]" />

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-sm font-semibold mb-6">
          <Shield className="w-4 h-4" />
          Start Your Resilience Journey
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-5">
          Ready to Transform Your BCM?
        </h2>
        <p className="text-base sm:text-lg text-slate-400 mb-10 max-w-2xl mx-auto leading-relaxed">
          Experience enterprise-grade business continuity management built on ISO 22301.
          Request access — our team will review your enquiry and provision a guided demo environment.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/request-demo">
            <Button size="lg" className="bg-sky-700 hover:bg-sky-800 text-white h-14 px-10 text-lg font-semibold shadow-lg shadow-sky-700/25 transition-all duration-300 hover:shadow-xl" data-testid="footer-cta-btn">
              Request Enquiry &amp; Demo
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
        <div className="flex items-center justify-center gap-6 mt-8 text-sm text-slate-500">
          <span className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-emerald-500" />
            No credit card
          </span>
          <span className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-emerald-500" />
            Approved-tenant access
          </span>
          <span className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-emerald-500" />
            White-glove onboarding
          </span>
        </div>
      </div>
    </section>
  );
}
